import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";
import { CongratsBoxApiResponseError, CongratsBoxApiResponseSuccess, getCongratsBox } from "./actions";
import { CongratsBoxActionTypes } from "./constants";
import { addCongratsBoxApi, getCongratsBoxApi, updateCongratsBoxApi, deleteCongratsBoxApi } from "../../helpers/api/congrats_box";

interface data {
  payload: {
    id: number;
    file: any;
    heading: string;
    heading_ar: string;
    sub_text: string;
    sub_text_ar: string;
  };
  type: string;
}

function* createCongratsBox({ payload: { file, heading, heading_ar, sub_text, sub_text_ar } }: data): SagaIterator {
  try {
    const response = yield call(addCongratsBoxApi, {
      file,
      heading,
      heading_ar,
      sub_text,
      sub_text_ar,
    });

    const data = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(CongratsBoxApiResponseSuccess(CongratsBoxActionTypes.CREATE_CONGRATS, data));
    yield put(getCongratsBox());
  } catch (error: any) {
    yield put(CongratsBoxApiResponseError(CongratsBoxActionTypes.CREATE_CONGRATS, error));
  }
}

function* updateCongratsBox({ payload: { file, heading, heading_ar, sub_text, sub_text_ar, id } }: data): SagaIterator {
  try {
    const response = yield call(updateCongratsBoxApi, id, {
      file,
      heading,
      heading_ar,
      sub_text,
      sub_text_ar,
    });
    const data = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(CongratsBoxApiResponseSuccess(CongratsBoxActionTypes.UPDATE_CONGRATS, data));
    yield put(getCongratsBox());
  } catch (error: any) {
    yield put(CongratsBoxApiResponseError(CongratsBoxActionTypes.UPDATE_CONGRATS, error));
  }
}

function* getCongratsBoxs(): SagaIterator {
  try {
    const response = yield call(getCongratsBoxApi);

    const data = response?.data?.data;

    yield put(CongratsBoxApiResponseSuccess(CongratsBoxActionTypes.GET_CONGRATS, data));
  } catch (error: any) {
    yield put(CongratsBoxApiResponseError(CongratsBoxActionTypes.GET_CONGRATS, error));
  }
}

function* deleteCongratsBox({ payload: { id } }: data): SagaIterator {
  try {
    const response = yield call(deleteCongratsBoxApi, id);
    const data = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(CongratsBoxApiResponseSuccess(CongratsBoxActionTypes.DELETE_CONGRATS, data));
    yield put(getCongratsBox());
  } catch (error: any) {
    yield put(CongratsBoxApiResponseError(CongratsBoxActionTypes.DELETE_CONGRATS, error));
  }
}

export function* watchCreateCongratsBox() {
  yield takeEvery(CongratsBoxActionTypes.CREATE_CONGRATS, createCongratsBox);
}
export function* watchUpdateCongratsBox() {
  yield takeEvery(CongratsBoxActionTypes.UPDATE_CONGRATS, updateCongratsBox);
}
export function* watchGetCongratsBox() {
  yield takeEvery(CongratsBoxActionTypes.GET_CONGRATS, getCongratsBoxs);
}

export function* watchDeleteCongratsBox() {
  yield takeEvery(CongratsBoxActionTypes.DELETE_CONGRATS, deleteCongratsBox);
}

function* CongratsBoxSaga() {
  yield all([fork(watchCreateCongratsBox), fork(watchUpdateCongratsBox), fork(watchDeleteCongratsBox), fork(watchGetCongratsBox)]);
}

export default CongratsBoxSaga;
